import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function LoadingScreen() {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setShow(false), 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="mf-loading"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          data-testid="loading-screen"
        >
          <div className="text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="font-display text-6xl sm:text-8xl tracking-tight"
              style={{ color: "#fff" }}
            >
              MASTER<span style={{ color: "var(--mf-orange)" }}>FIT</span>
            </motion.div>
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: "100%" }}
              transition={{ duration: 1.2, ease: "easeInOut" }}
              className="mt-4 h-[2px] mx-auto"
              style={{
                background: "linear-gradient(90deg, transparent, #FF6B00, transparent)",
                maxWidth: 280,
              }}
            />
            <div
              className="mt-3 text-xs tracking-[0.4em] text-zinc-500 uppercase"
            >
              Jorge Aguilar
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
